<app-toolbar></app-toolbar>
<div class="d-block" id="wrapper" [ngClass]="{ toggled: toggle }">
  <mat-drawer-container autosize>
    <mat-drawer #drawer mode="over">
      <nav class="y-navbar" [ngClass]="{ 'navigation-disabled': disableNavigation() }">
        <ul class="y-navbar-nav">
          <!-- FOTO DE PERFIL -->
          <li class="li-profile">
            <div [class.active-item]="currentNav === '/user/my-commerce'">
              <app-header></app-header>
            </div>
          </li>

          <!-- INICIO -->
          <li *ngIf="hasPermission(permissions.INICIO)" class="y-nav-item" (click)="navigate('/user/account-yacare')">
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/account-yacare'">
              <img src="assets/icons/cash-coin.svg" />
              <span class="y-nav-link-text"> Saldo </span>
            </div>
          </li>

          <!-- COBRAR (OPCIONES) -->
          <li *ngIf="hasPermission(permissions.COBRAR)" class="y-nav-item" (click)="navigate('/user/cashin-cashout')">
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/cashin-cashout'">
              <img src="assets/icons/cobrar-qr.svg" alt="Cobrar" />
              <span class="y-nav-link-text"> Cobrar </span>
            </div>
          </li>

          <!-- MOVIMIENTOS -->
          <li *ngIf="hasPermission(permissions.MOVIMIENTO)" class="y-nav-item" (click)="navigate('/user/movements')">
            <div class="y-nav-link" [class.active-item]="currentNav.includes('/user/movements')">
              <img src="assets/icons/movs.svg" />
              <span class="y-nav-link-text"> Movimientos </span>
            </div>
          </li>

          <!-- TRANSFERENCIAS -->
          <li
            *ngIf="hasPermission(permissions.TRANSFERENCIA)"
            class="y-nav-item"
            (click)="navigate('/user/cashout/transfer')"
          >
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/cashout/transfer'">
              <img src="assets/icons/arrow-left-right.svg" alt="Transferencias" />
              <span class="y-nav-link-text"> Transferencias </span>
            </div>
          </li>

          <!-- MI COMERCIO -->
          <li *ngIf="hasPermission(permissions.MI_COMERCIO)" class="y-nav-item" (click)="navigate('/user/my-commerce')">
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/my-commerce'">
              <img src="assets/icons/comercio.svg" />
              <span class="y-nav-link-text">Mi comercio</span>
            </div>
          </li>

          <!-- MENSAJES -->
          <li class="y-nav-item" (click)="navigate('/user/inbox')">
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/inbox'">
              <img src="assets/icons/mensajes.svg" />
              <span class="y-nav-link-text">
                {{ translate('components.menu.messages') }}
              </span>
            </div>
          </li>

          <!-- AYUDA -->

          <li class="y-nav-item" (click)="navigate('/user/help')">
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/help'">
              <img src="assets/icons/info.svg" />
              <span class="y-nav-link-text">Ayuda</span>
            </div>
          </li>

          <!-- CERRAR SESION -->
          <li class="y-nav-item" (click)="closeSessionEventHandler()">
            <div class="y-nav-link">
              <img src="assets/icons/exit.svg" />
              <span class="y-nav-link-text">
                {{ translate('components.menu.end_session') }}
              </span>
            </div>
          </li>
        </ul>
      </nav>
    </mat-drawer>

    <div>
      <div class="show-or-no">
        <button class="burger-button" type="button" mat-button (click)="drawer.toggle()">
          <mat-icon class="burger-icon">menu</mat-icon>
        </button>
        <img class="container-header" src="assets/images/logo-fiserv.png" alt="cargando imagen" />
      </div>
      <nav class="y-navbar2" [ngClass]="{ 'navigation-disabled': disableNavigation() }">
        <ul class="y-navbar-nav">
          <!-- FOTO DE PERFIL -->
          <li class="li-profile">
            <div [class.active-item]="currentNav === '/user/my-commerce'">
              <app-header></app-header>
            </div>
          </li>

          <!-- SALDO -->
          <li class="y-nav-item" (click)="navigate('/user/account-yacare')" *ngIf="hasPermission(permissions.INICIO)">
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/account-yacare'">
              <img src="assets/icons/cash-coin.svg" alt="Inicio" />
              <span class="y-nav-link-text"> Saldo </span>
            </div>
          </li>

          <!-- COBRAR (OPCIONES) -->
          <li *ngIf="hasPermission(permissions.COBRAR)" class="y-nav-item" (click)="navigate('/user/cashin-cashout')">
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/cashin-cashout'">
              <img src="assets/icons/cobrar-qr.svg" alt="Cobrar" />
              <span class="y-nav-link-text"> Cobrar </span>
            </div>
          </li>

          <!-- MOVIMIENTOS -->
          <li *ngIf="hasPermission(permissions.MOVIMIENTO)" class="y-nav-item" (click)="navigate('/user/movements')">
            <div class="y-nav-link" [class.active-item]="currentNav.includes('/user/movements')">
              <img src="assets/icons/movs.svg" alt="Movimientos" />
              <span class="y-nav-link-text"> Movimientos </span>
            </div>
          </li>

          <!-- TRANSFERENCIAS -->
          <li
            class="y-nav-item"
            *ngIf="hasPermission(permissions.TRANSFERENCIA)"
            (click)="navigate('/user/cashout/transfer')"
          >
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/cashout/transfer'">
              <img src="assets/icons/arrow-left-right.svg" alt="Transferencias" />
              <span class="y-nav-link-text"> Transferencias </span>
            </div>
          </li>

          <!-- MI COMERCIO -->
          <li class="y-nav-item" *ngIf="hasPermission(permissions.MI_COMERCIO)" (click)="navigate('/user/my-commerce')">
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/my-commerce'">
              <img src="assets/icons/comercio.svg" alt="Mi comercio" />
              <span class="y-nav-link-text"> Mi comercio </span>
            </div>
          </li>

          <!-- MENSAJES -->
          <li class="y-nav-item" (click)="navigate('/user/inbox')">
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/inbox'">
              <img src="assets/icons/mensajes.svg" alt="Mensajes" />
              <span class="y-nav-link-text">
                {{ translate('components.menu.messages') }}
              </span>
            </div>
          </li>

          <!-- AYUDA -->

          <li class="y-nav-item" (click)="navigate('/user/help')">
            <div class="y-nav-link" [class.active-item]="currentNav === '/user/help'">
              <img src="assets/icons/info.svg" />
              <span class="y-nav-link-text">Ayuda</span>
            </div>
          </li>

          <!-- CERRAR SESION -->
          <li class="y-nav-item" (click)="closeSessionEventHandler()">
            <div class="y-nav-link">
              <img src="assets/icons/exit.svg" alt="Cerrar sesion" />
              <span class="y-nav-link-text">
                {{ translate('components.menu.end_session') }}
              </span>
            </div>
          </li>
        </ul>
      </nav>
      <main>
        <div [attr.id]="contanerId" class="pcoded-content" [ngStyle]="{ padding: isPixPayNav ? '0px !important' : '' }">
          <router-outlet>
            <layout-spinner></layout-spinner>
          </router-outlet>
        </div>
      </main>
    </div>
  </mat-drawer-container>
</div>
